module.exports = __webpack_public_path__ + "static/assets/99b2b7361d516f2054b3bf8fbc015252.png";